import { Component, OnInit } from '@angular/core';
import {DomainService} from '../shared/services/domain.service';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    standalone: false
})
export class AdminComponent implements OnInit {

  constructor(public domain: DomainService) { }

  ngOnInit(): void {
  }

}
